/* @eslint-disable */
import {createApp } from 'vue';
import App from './App.vue'
import router from './router';
import { IonicVue } from '@ionic/vue';

// By adding the following two lines to tsconfig.json:
// "noImplicitAny": false,
// "allowJs": true,
// TS/ESLint is a lot less painful with our plugins

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.scss';

import './theme/custom.scss';

import { defineCustomElements } from '@ionic/pwa-elements/loader';
import EventBus from "@/EventBus";
//import IonicDeploy from './services/IonicDeploy';
import ZebraHardwareScanner from './services/ZebraHardwareScanner';

/* Our services */
// instantiate Storage early so that, if we have an
// authenticated user, we can emit the fact that they're
// logged in and then the Axios service will tack on the
// api key to all requests ...
import Storage from './services/Storage';
import BarcodeScanner from './services/BarcodeScanner';

// this is a bit early for the app to be honest, so it's
// only the Axios plugin which is even able to listen for
// this event ...
const storage = new Storage();
storage.get('user').then( async (user: any) => {
  if (user && user.api_token) {
    EventBus().emitter.emit('auth.login', user);
  }
});

const app = createApp(App as any)
    .use(IonicVue)
    .use(router)
    .use(require('./plugins/Toast').default)
    .use(require('./plugins/Axios').default)
    .use(require('./plugins/ValidationErrors').default)
    .use(require('./plugins/Filters').default);

router.isReady().then(() => {
  app.mount('#app');

  //window["plugins"].OneSignal.setLogLevel({logLevel: 6, visualLevel: 0});
  window["plugins"].OneSignal
      .startInit(process.env.VUE_APP_ONE_SIGNAL_ID)
      .handleNotificationOpened(cb => {
        console.log(cb);
      })
      .inFocusDisplaying(window["plugins"].OneSignal.OSInFocusDisplayOption.Notification)
      .endInit();
});


/*
const deploy = new IonicDeploy(
    process.env.VUE_APP_IONIC_APP_ID,
    process.env.VUE_APP_IONIC_APP_CHANNEL
);
deploy.check();
*/

app.config.globalProperties.$version = process.env.VUE_APP_VERSION;
app.config.globalProperties.$assets = {
  missingImageUrl: process.env.VUE_APP_API_BASE_URL + '/assets/img/no-product-image.jpg'
};
// app.config.globalProperties.$deploy = deploy;
// ---------------------------------------------------------------------------

defineCustomElements(window);

// Because we inject $zebra into components ASAP
// we need to make sure that $zebra is available
// immediately, but it might take a while before
// we can notify everyone that it's ready ...
const zebra = new ZebraHardwareScanner();
app.provide('$zebra', zebra);
app.provide('$scanner', new BarcodeScanner(zebra));

